import { appApi } from "../api";

export type ModuleDTO = {
	id: number;
	description: string;
};

export async function getAllModules() {
	const { data } = await appApi.get<ModuleDTO[]>("/Module/All");
	return data || [];
}
